function _metodologyInit(element, index) {
  var parent = $(element).parents('.section-metodology').find('svg');
  var cursor = parent.find('.cursor');

  parent.find('.svg-metodology-invert').removeClass('svg-metodology-invert');

  cursor.removeClass('step-1 step-2 step-3 step-4 step-5');
  cursor.addClass('step-' + index);

  parent.find('.step').removeClass('active');
  parent.find('.step[data-index="' + index + '"]').addClass('active');

  if (index == 1) {
    setTimeout(function() {
      cursor.removeClass('step-1');
    }, 750);
  } else {
    parent.find('g[data-index="' + index + '"] .st0').addClass('svg-metodology-invert');
  }

  $('.step-content').removeClass('active');
  $('.step-content[data-index="' + index + '"]').addClass('active');  
}

export function ComponentMetodology() {
  $('.section-metodology .step').on('click', function(e) {
    e.preventDefault();

    _metodologyInit(this, $(this).data('index'));
  }).on('mouseenter', function() {
    var index = $(this).data('index');

    $('.hover').removeClass('active');
    $('.hover[data-index="' + index + '"]').addClass('active');
  }).on('mouseleave', function() {
    $('.hover').removeClass('active');
  });;

  $('.section-metodology .carousel-control-prev').on('click', function(e) {
    e.preventDefault();

    var index = $('.step-content.active').index();
    if (index == 0) index = $('.step-content').length; 

    _metodologyInit(this, index);
  });

  $('.section-metodology .carousel-control-next').on('click', function(e) {
    e.preventDefault();

    var index = $('.step-content.active').index() + 2;
    if (index > $('.step-content').length) index = 1; 

    _metodologyInit(this, index);
  });
}
